module.exports = __webpack_public_path__ + "img/4-find.cd53c3c8.svg";